<script>
    import {onDestroy, onMount} from "svelte";
    /**
     * @typedef {Object} Props
     * @property {string} [accept]
     * @property {boolean} [autoOpen]
     * @property {(detail: {
     *   originalEvent: Event,
     *   file: File,
     *   fileBytes: Uint8Array,
     *   fileName: string,
     *   fileExtension: string | undefined
     * }) => void} [change]
     * @property {() => void} [cancel]
     */

    /** @type {Props & { [key: string]: any }} */
    let { accept = "*/*", autoOpen = false, change, cancel, ...rest } = $props();

    let inputFile = $state();

    async function handleFileInput(event) {
        const files = event.target.files;

        if (files.length === 0) {
            return;
        }

        const file = files[0];
        const fileBytes = await readFileAsByteArray(file);
        const fileName = file.name;
        const fileExtension = file.name.split('.').pop();

        change?.({
            originalEvent: event,
            file,
            fileBytes,
            fileName,
            fileExtension
        });
    }

    function readFileAsByteArray(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                resolve(new Uint8Array(reader.result));
            };
            reader.onerror = reject;
            reader.readAsArrayBuffer(file);
        });
    }


    const componentUploadOpenCallback = () => uploadOpenCallback(inputFile);
    const componentUploadCloseCallback = () => uploadCloseCallback(inputFile);

    function uploadOpenCallback(inputFileRef) {
        if (inputFile === inputFileRef) {
            inputFile.removeEventListener('click', componentUploadOpenCallback);
            jQuery(window).on('focus', componentUploadCloseCallback);
        }
    }

    function uploadCloseCallback(inputFileRef) {
        if (inputFile === inputFileRef) {
            jQuery(window).unbind('focus', componentUploadCloseCallback);
            inputFile.addEventListener('click', componentUploadOpenCallback);

            setTimeout(() => {
                if (inputFile.files.length === 0) {
                    cancel?.();
                }
            }, 750);
        }
    }

    onMount(() => {
        inputFile.addEventListener('click', componentUploadOpenCallback);

        if (autoOpen) {
            inputFile.click();
        }
    });

    onDestroy(() => {
        inputFile.removeEventListener('click', componentUploadOpenCallback);
        jQuery(window).unbind('focus', componentUploadCloseCallback);
    });
</script>

<!--TODO-? Migrate to Bootstrap Input. For now it is ok, because we are just using it as hidden field.-->
<input {...rest} {accept} onchange={handleFileInput} type="file" bind:this={inputFile} />
